<!--suppress XmlDuplicatedId -->
@if (hasDescription()) {
  <div
    >
    <div
      [ngClass]="'c-accordion ' + (softSkillSelected ? '-is-open' : '-is-closed')">
      <div id="occupational-profile-soft-skill-item-{{index}}" class="c-accordion__header"
        (click)="clickAccordionHeader(softSkill, $event)">
        <h3 class="mb0">
          <button class="c-accordion__button" aria-expanded="false">
            {{softSkill.title.nl}}
          </button>
        </h3>
        <a [ngClass]="'c-accordion__toggle-btn ' + (softSkillSelected ? 'action-hide' : 'action-show')"></a>
      </div>
      <div class="c-accordion__content" aria-hidden="true">
        <div class="c-skills__content">
          <p>{{softSkill.description.nl}}</p>
        </div>
      </div>
    </div>
  </div>
}
@if (!hasDescription()) {
  <div
    >
    <div id="occupational-profile-soft-skill-item-{{index}}" class="c-skills__non-accordion-item">
      <h3 class="h5 mb0">
        {{softSkill.title.nl}}
      </h3>
    </div>
  </div>
}

